import win from '../lib/win';

let vTitle;

export default {
	focus: {
		inserted(el, binding, vnode) {
			if (binding.value && binding.value.minWidth) {
				if (win.width < binding.value.minWidth) return;
			}
			el.focus();
		}
	},
	'block-scroll': {
		bind(el, binding, vNode) {
			let handler = e => {
				e.stopPropagation();

				if (el.scrollHeight <= el.offsetHeight) return;

				if (
					e.deltaY < 0 && el.scrollTop <= 0 ||
					e.deltaY > 0 && el.scrollTop + el.offsetHeight >= el.scrollHeight
				) {
					e.preventDefault();
				}
			};

			el.__vueMousewheelOutside__ = handler;

			el.addEventListener('wheel', handler);
		},
		unbind(el) {
			el.addEventListener('wheel', el.__vueMousewheelOutside__);
		}
	},
	'mousedown-outside': {
		bind(el, binding, vNode) {
			if (typeof binding.value !== 'function') {
				const compName = vNode.context.name;
				let warn = `[Vue-mousedown-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
				if (compName) {
					warn += `Found in component '${compName}'`;
				}

				console.warn(warn);
			}

			const bubble = binding.modifiers.bubble;
			const handler = (e) => {
				if (bubble || (!el.contains(e.target) && el !== e.target)) {
					binding.value(e);
				}
			};
			el.__vueMousedownOutside__ = handler;

			document.addEventListener('mousedown', handler);
		},

		unbind(el, binding) {
			document.removeEventListener('mousedown', el.__vueMousedownOutside__);
			el.__vueMousedownOutside__ = null;
		}
	},
	title: {
		update(el, binding, vNode) {
			vTitle.innerText = binding.value;
		},
		bind(el, binding, vNode) {
			if (!vTitle) {
				vTitle = document.createElement('div');
				vTitle.className = 'title';
				document.body.appendChild(vTitle);
			}
			el.addEventListener('mouseenter', e => {
				if (!binding.value) return;

				vTitle.textContent = binding.value;
				let elRect = vNode.elm.getBoundingClientRect();
				let left, bottom;

				left = elRect.left + win.scrollLeft + (vNode.elm.offsetWidth - vTitle.offsetWidth) / 2;
				bottom = win.height - elRect.top - win.scrollTop;

				vTitle.style.visibility = 'visible';
				vTitle.style.left = left + 'px';
				vTitle.style.top = 'auto';
				vTitle.style.bottom = bottom + 'px';

				el.addEventListener('mouseleave', function leave() {
					vTitle.style.visibility = 'hidden';
					vTitle.style.left = '0px';
					vTitle.style.bottom = '100%';
					el.removeEventListener('mouseleave', leave);
				});
			});
		},
		unbind(el, binding, vNode) {
			vTitle.style = {
				visibility: 'hidden'
			};
		}
	},
};
